/* akk-cookie.js: shows the cookie notice once and records the answer.
   The answer goes to Shopify's Customer Privacy API when it is available, so
   consent-aware pixels and app embeds follow it, and is kept in localStorage
   so the card does not return. Without the API the card still works as a
   remembered notice. */

(() => {
  'use strict';
  if (window.__akkCookieLoaded) return;
  window.__akkCookieLoaded = true;

  const KEY = 'akk:cookies:v1';
  const card = document.querySelector('[data-akk-cookie]');
  if (!card) return;

  const read = () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } };
  const write = (value) => { try { localStorage.setItem(KEY, value); } catch (e) { /* private mode */ } };
  const api = () => (window.Shopify && window.Shopify.customerPrivacy) || null;

  const decidedInShopify = () => {
    const privacy = api();
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return false;
    let consent = {};
    try { consent = privacy.currentVisitorConsent() || {}; } catch (e) { return false; }
    return Object.keys(consent).some((key) => consent[key] === 'yes' || consent[key] === 'no');
  };

  let shown = false;
  const show = () => {
    if (shown || read()) return;
    shown = true;
    card.hidden = false;
    document.documentElement.classList.add('akk-cookie-open'); /* the product page hides its buy bar while the notice owns the bottom edge */
    requestAnimationFrame(() => card.classList.add('is-visible'));
  };
  const hide = () => {
    card.classList.remove('is-visible');
    card.hidden = true;
    document.documentElement.classList.remove('akk-cookie-open');
  };

  const decide = (accepted) => {
    write(accepted ? 'accept' : 'decline');
    const privacy = api();
    if (privacy && typeof privacy.setTrackingConsent === 'function') {
      try {
        privacy.setTrackingConsent(
          { analytics: accepted, marketing: accepted, preferences: accepted, sale_of_data: accepted },
          () => {}
        );
      } catch (e) { /* the local record still stands */ }
    }
    hide();
  };

  const maybeShow = () => {
    if (read()) return;
    if (decidedInShopify()) { write('shopify'); return; }
    show();
  };

  card.addEventListener('click', (event) => {
    if (event.target.closest('[data-akk-cookie-accept]')) decide(true);
    else if (event.target.closest('[data-akk-cookie-decline]')) decide(false);
  });

  if (read()) return;
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => maybeShow());
    setTimeout(maybeShow, 2000);
  } else {
    maybeShow();
  }
})();
